// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__J9yrZ","inlineCheckbox":"Checkbox_inlineCheckbox__NPmQE"};